import { AuthContext } from 'context/authContext';
import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';
import { useContext } from 'react';
import { useQuery } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

export default function useGetSkillDevelopment() {
  const { authState } = useContext(AuthContext);

  return useQuery(['employee-skills-development'], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.SKILL_DEVELOPMENT_API, {
        employee_id: authState?.employee_id,
      })
    );

    return response.data;
  });
}
